export default [
  {
    path: '/student-scoring-component-entries',
    name: 'student-scoring-component-entry',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-scoring-component-entry/index.vue')
  },
  {
    path: '/student-scoring-component-entries/create',
    name: 'student-scoring-component-entry-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-scoring-component-entry/create.vue')
  }
]
